import Vue from 'vue';
import TrustpilotTrustbox from '@/components/trustpilot-trustbox';
import Faq from '@/components/faq';
import Navbar from '@/components/navbar';
import MobileNav from '@/components/mobile-nav';
import SiteFooter from '@/components/site-footer';

Vue.component('trustpilot-trustbox', TrustpilotTrustbox);
Vue.component('faq', Faq);
Vue.component('navbar', Navbar);
Vue.component('mobile-nav', MobileNav);
Vue.component('site-footer', SiteFooter);